import styled from 'styled-components';

export const SummaryBox = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 15px 30px;
  font-family: Poppins-Regular;
  font-size: 14px;
  line-height: 21px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 15px 0;
  border-top: 1px solid #BFBEBE;
`;

export const Subtitle = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #3C3B3B;
`;

export const Title = styled.span`
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  color: #3C3B3B;
`;

export const CancelBtn = styled.div`
  background: transparent;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
  border-radius: 500px;
  padding: 10px 45px;
  width: auto;
  cursor: pointer;
  color: #D40020;
  font-family: Poppins-Bold;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin: 0;
  border: 1px solid #D40020;
  min-width: 200px;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  &[disabled] {
    pointer-events: none;
    opacity: 0.8;
  }
`;